/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import Vue from 'vue';
import cacheAxios from '../../util/cacheAxios';

const newsAxios = axios.create();
const cache = new Map();
cacheAxios(newsAxios, cache);
newsAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/news/biz';
      }, 500);
    }
  });

export default {
  state: {
    bizSortBy: 'sentiment',
    searchText: '',
    newsLoading: false,
    startDate: '',
    endDate: '',
    countrySelected: '',
    newsIndexes: [],
    negativeCountryNews: [],
    positiveCountryNews: [],
    startDateFilter: '',
    endDateFilter: '',
    industryFilter: {},
    industries: {},
    loading: true,
    newsChartOptions: {
      backgroundColor: '#fff',
      title: {
        text: 'Market Sentiments',
        subtext: 'Worldwide',
        left: 'center',
        top: 'top',
        subtextStyle: {
          fontSize: 16,
          color: '#333',
        },
        textStyle: {
          color: '#333',
        },
      },
      tooltip: {
        trigger: 'item',
      },
      visualMap: {
        type: 'continuous',
        min: -100,
        max: 100,
        text: ['Positive', 'Negative'],
        realtime: true,
        calculable: false,
        dimension: 0,
        inRange: {
          color: ['#f00', '#c00', '#900', '#aaa', '#090', '#0c0', '#0f0'],
        },
        textStyle: {
          color: '#111',
        },
      },
      series: [
        {
          name: 'News Sentiments',
          type: 'map',
          mapType: 'world',
          roam: true,
          selectedMode: 'single',
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.8)',
              borderWidth: 0,
              areaColor: '#e2e2e2',
            },
            emphasis: {
              borderColor: '#a0bfff',
              borderWidth: 2,
              areaColor: '#200fff',
            },
          },
          data: [],
        },
      ],
    },
  },
  mutations: {
    setBizSortBy(state, sort) {
      state.bizSortBy = sort;
    },
    setSearchText(state, text) {
      state.searchText = text;
    },
    setNewsIndexes(state, indexes) {
      state.newsIndexes = indexes;
    },
    setNewsLoading(state, loading) {
      state.newsLoading = loading;
    },
    setPositiveCountryNews(state, news) {
      state.positiveCountryNews = news;
    },
    setNegativeCountryNews(state, news) {
      state.negativeCountryNews = news;
    },
    appendPositiveCountryNews(state, news) {
      state.positiveCountryNews = [...state.positiveCountryNews, ...news];
    },
    appendNegativeCountryNews(state, news) {
      state.negativeCountryNews = [...state.negativeCountryNews, ...news];
    },
    setCountrySelected(state, country) {
      state.countrySelected = country;
      const mappedData = state.newsChartOptions.series[0].data.map((c) => {
        if (c.name === state.countrySelected) {
          c.selected = true;
        } else {
          c.selected = false;
        }
        return c;
      });
      const series0 = { ...state.newsChartOptions.series[0],
        data: mappedData,
      };
      const cty = country === '' ? 'Worldwide' : country;
      const title = {
        ...state.newsChartOptions.title,
        subtext: cty,
      };
      state.newsChartOptions = {
        ...state.newsChartOptions,
        series: [series0],
        title,
      };
    },
    addIndustryFilter(state, industry) {
      Vue.set(state.industryFilter, industry, true);
    },
    removeIndustryFilter(state, industry) {
      Vue.set(state.industryFilter, industry, false);
    },
    setData(state, data) {
      const mappedData = data.map((c) => {
        if (c.name === state.countrySelected) {
          c.selected = true;
        } else {
          c.selected = false;
        }
        return c;
      });
      const series0 = { ...state.newsChartOptions.series[0],
        data: mappedData,
      };
      state.newsChartOptions = {
        ...state.newsChartOptions,
        series: [series0],
      };
    },
    setStartDate(state, date) {
      state.startDate = date;
    },
    setEndDate(state, date) {
      state.endDate = date;
    },
    setIndustries(state, industries) {
      state.industries = industries;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setStartDateFilter(state, startDate) {
      state.startDateFilter = startDate.toISOString()
        .slice(0, 10);
    },
    setEndDateFilter(state, endDate) {
      state.endDateFilter = endDate.toISOString()
        .slice(0, 10);
    },
  },
  actions: {
    initNewsData({
      commit,
      state,
      dispatch,
    }) {
      newsAxios.get('/aims/api/news/industry/all')
        .then((res) => {
          if (res.status === 200) {
            const industryMapNew = {};
            res.data.forEach((industry) => {
              industryMapNew[`${industry.source}-${industry.category}`] = industry;
            });
            commit('setIndustries', industryMapNew);
          }
        });
    },
    changeBizSortBy({
      state, commit, dispatch,
    }, sortBy) {
      if (sortBy === state.bizSortBy) {
        return;
      }
      commit('setBizSortBy', sortBy);
      dispatch('getNews');
    },
    getNews({
      commit,
      dispatch,
    }) {
      commit('setPositiveCountryNews', []);
      commit('setNegativeCountryNews', []);
      dispatch('getMorePositiveNews');
      dispatch('getMoreNegativeNews');
    },

    getMorePositiveNews({
      state,
      commit,
    }) {
      commit('setNewsLoading', true);
      if (state.positiveCountryNews.length !== 0 && state.positiveCountryNews.length % 20 !== 0) {
        commit('setNewsLoading', false);
        return;
      }
      const industries = Object.keys(state.industryFilter)
        .filter(k => state.industryFilter[k])
        .map(k => k.toLowerCase());
      const postPosBody = {
        start: state.startDateFilter,
        end: state.endDateFilter,
        industries: industries.sort(),
        country: state.countrySelected,
        sentiment_type: 'positive',
        sortBy: state.bizSortBy,
        searchText: state.searchText.trim(),
        fromIndex: state.positiveCountryNews.length,
      };
      newsAxios.post('/aims/api/news/newsByDateAndIndustries', postPosBody, {
          cache: true,
          cacheKey: JSON.stringify(postPosBody),
        })
        .then((res) => {
          if (!res.data) {
            commit('setNewsLoading', false);
            return;
          }
          const data = res.data.map((news) => {
            const published = new Date(news.published);
            news.published = published.toISOString()
              .slice(0, 10);
            return news;
          });
          data.sort((a, b) => {
            if (a.published < b.published) {
              return 1;
            } else if (a.published > b.published) {
              return -1;
            }
            return 0;
          });
          commit('appendPositiveCountryNews', data);
          commit('setNewsLoading', false);
        });
    },
    getMoreNegativeNews({
      state,
      commit,
    }) {
      commit('setNewsLoading', true);
      if (state.negativeCountryNews.length !== 0 && state.negativeCountryNews.length % 20 !== 0) {
        commit('setNewsLoading', false);
        return;
      }
      const industries = Object.keys(state.industryFilter)
        .filter(k => state.industryFilter[k])
        .map(k => k.toLowerCase());
      const postNegBody = {
        start: state.startDateFilter,
        end: state.endDateFilter,
        industries: industries.sort(),
        country: state.countrySelected,
        sentiment_type: 'negative',
        sortBy: state.bizSortBy,
        searchText: state.searchText.trim(),
        fromIndex: state.negativeCountryNews.length,
      };
      newsAxios.post('/aims/api/news/newsByDateAndIndustries', postNegBody, {
          cache: true,
          cacheKey: JSON.stringify(postNegBody),
        })
        .then((res) => {
          if (!res.data) {
            commit('setNewsLoading', false);
            return;
          }
          const data = res.data.map((news) => {
            const published = new Date(news.published);
            news.published = published.toISOString()
              .slice(0, 10);
            return news;
          });
          data.sort((a, b) => {
            if (a.published < b.published) {
              return 1;
            } else if (a.published > b.published) {
              return -1;
            }
            return 0;
          });
          commit('appendNegativeCountryNews', data);
          commit('setNewsLoading', false);
        });
    },

    getNewsIndex({
      commit,
    }) {
      newsAxios.get('/aims/api/companyIndexes/newsIndexes')
        .then((res) => {
          commit('setNewsIndexes', res.data);
        });
    },
    filterDataByDate({
      commit,
      getters,
      dispatch,
    }, dateSelection) {
      commit('setStartDateFilter', dateSelection[0]);
      commit('setEndDateFilter', dateSelection[1]);
      dispatch('getScoreByDateAndIndustries');
    },

    getScoreByDateAndIndustries({
      state,
      commit,
    }) {
      const industries = Object.keys(state.industryFilter)
        .filter(k => state.industryFilter[k])
        .map(k => k.toLowerCase());
      const postBody = {
        start: state.startDateFilter,
        end: state.endDateFilter,
        industries: industries.sort(),
      };
      newsAxios.post(
          '/aims/api/news/scoreByDateAndIndustries', postBody, {
            cache: true,
            cacheKey: JSON.stringify(postBody),
          },
        )
        .then((res) => {
          commit('setData', res.data);
          commit('setLoading', false);
        });
    },
  },
  getters: {

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/newsModule.js